// Import React, styles, SVG icons, and navigation hook
import React from "react";
import { ReactComponent as LinkedInIcon } from "../../assets/icons/linkedin.svg";
import { ReactComponent as PhoneIcon } from "../../assets/icons/phone.svg";
import { ReactComponent as EmailIcon } from "../../assets/icons/email.svg";
import { useNavigate } from "react-router-dom";

/**
 * Footer component displays contact info, social links, and legal disclaimers.
 */
function Footer() {
  // useNavigate hook for client-side navigation
  const navigate = useNavigate();
  return (
    <footer className="background-container  bg-gray-3" id="contact">
      {/* <div className="content-container"> */}
      {/* <div className="row space-between align-center"> */}
      {/* Contact section with email and phone */}
      {/* <div className="row gap-l align-center">
            <div className="row gap-m align-center">
              <span className="icon">
                <EmailIcon />
              </span>
              <span>
                <a
                  href="mailto:enquiries@fgwealthadvisory.co.uk"
                  className="content primary"
                >
                  enquiries@fgwealthadvisory.co.uk
                </a>
              </span>
            </div>
            <div className="row gap-m align-center">
                <PhoneIcon />
              <span className="icon">
              </span>
              <span>
                <a href="tel:07759727170" className="content primary">
                  033 3366 0988
                </a>
              </span>
            </div>
          </div> */}
      {/* Social media links */}
      {/* <div className="row gap-l align-center">
            <a
              href="https://www.instagram.com/avarosemortgages/"
              target="_blank"
              rel="noopener noreferrer"
              // className="social-icon facebook"
              aria-label="Instagram"
            >
              <LinkedInIcon />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61580737965094"
              target="_blank"
              rel="noopener noreferrer"
              // className="social-icon facebook"
              aria-label="Facebook"
            >
              <LinkedInIcon />
            </a>

            <a
              href="https://www.linkedin.com/company/fgwealthadvisory/"
              // className="social-icon linkedin"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <LinkedInIcon />
            </a>
          </div> */}
      {/* </div> */}
      {/* </div> */}
      {/* Legal disclaimer and privacy policy link */}
      <div className="background-container  bg-primary-1 gap-m">
        <div className="content-container column gap-s align-center py-xxxl">
          {/* <h2
          style={{ textDecoration: "underline", cursor: "pointer" }}
          onClick={() => navigate("/privacy-policy")}
        >
          Privacy Policy
        </h2> */}
          <div className="body1">
            AK Mortgage Solutions Ltd is an Appointed Representative of
            Rosemount Financial Solutions (IFA) Ltd which is authorised and
            regulated by the Financial Conduct Authority. Rosemount Financial
            Solutions (IFA) Ltd is entered on the Financial Services Register
            under reference 535515.
            {/*
            <a
              href="https://register.fca.org.uk/s/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "underline" }}
            >
              (https://register.fca.org.uk/s/)
            </a>
            under reference 535515. Rosemount Financial Solutions (IFA) Ltd is
            authorised and regulated by the Financial Conduct Authority.
          */}
          </div>

          <div className="body1">
            AK Mortgage Solutions Ltd is registered in England and Wales
            (Company Number: 16765540). Registered Address: 28 Stanshaw Close,
            Bristol, England, BS16 1JY. The information on this website is
            subject to the UK regulatory regime and is intended for consumers in
            the UK.
          </div>
          <div className="body2-semibold">
            Read the{" "}
            <span
              className="body2-semibold"
              onClick={() => navigate("/privacy-policy")}
              style={{ cursor: "pointer", textDecoration: "underline" }}
            >
              Privacy Policy
            </span>{" "}
            here.
          </div>
        </div>
      </div>
    </footer>
  );
}

// Export the Footer component as default
export default Footer;
